import classNames from "classnames";

interface PageHeaderProps {
  title: React.ReactNode;
  description?: string;
  className?: string;
}

export default function PageHeader(props: PageHeaderProps) {
  const { title, description, className } = props;
  return (
    <div className={classNames("flex flex-row items-start", className)}>
      <div className="flex flex-start h-full">
        <h1 className="text-3xl">{title}</h1>
        {description && (
          <div className="flex items-end h-full justify-end pl-2">
            {description && (
              <div className="text-sm text-gray-500 italic">{description}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
